import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

/**
 * Avertissement affiché quand la création d'une commande dépasserait
 * l'effectif d'ouvriers disponibles.
 */
export const WorkforceWarningDialog = ({ warning, onClose, onConfirm }) => {
  return (
    <AlertDialog open={!!warning} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid="workforce-warning-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>⚠️ Dépassement d'effectif ouvriers</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-sm">
              <p>
                Vous avez <strong>{warning?.data?.total_workers}</strong> ouvrier(s) actif(s).
                Cette commande nécessite <strong>{warning?.data?.executants_needed}</strong> exécutant(s).
              </p>
              <p>
                Sur la période calculée, il y a <strong>{warning?.data?.warnings?.length}</strong> jour(s)
                en sur-effectif. Exemple :
              </p>
              {warning?.data?.warnings?.slice(0, 3).map((w, i) => (
                <div key={i} className="bg-amber-50 border border-amber-200 rounded p-2">
                  <div className="font-medium">{w.date}</div>
                  <div className="text-xs text-muted-foreground">
                    {w.workers_used}/{warning.data.total_workers} utilisés
                    • manque {w.shortage} ouvrier(s)
                  </div>
                </div>
              ))}
              <p className="text-xs">
                💡 Vous pouvez soit assigner un sous-traitant, soit confirmer quand même
                (la commande sera créée avec un conflit de planning).
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="cancel-workforce">Annuler et ajuster</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} data-testid="confirm-workforce">
            Créer quand même
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default WorkforceWarningDialog;
